import React from "react";

import Color from "../Color";

class LevelControl extends React.Component {
  expandOrCollapseLevel = () => {
    const { collapsed } = this.props;
    this.props.expandOrCollapseLevel(!collapsed);
  };

  render() {
    const { level, collapsed, scale } = this.props;
    return (
      <g transform={`translate(55, -5)`}>
        <rect x="-100" y={6} height={150} width="135" fill="#fff" />
        <rect x="-100" y={-150} height={155} width="135" fill="#fff" />
        <line
          x1={-160}
          y1="5"
          x2="35"
          y2="5"
          strokeWidth={1}
          stroke={Color.gradientMid}
          strokeDasharray="10,10"
        />
        <line
          x1={-150}
          y1="5"
          x2="35"
          y2="5"
          strokeWidth={1}
          stroke={Color.initial}
          strokeDasharray="10,10"
        />
        <g
          transform={`translate(-55, 5) scale(${1 / scale}) translate(55, -5)`}
        >
          <text fill={Color.primary} fontSize={16} x="0" y="0" textAnchor="end">
            Level {level + 1}
          </text>
          <image
            x="5"
            y="-16"
            className="clickable"
            width="16"
            height="16"
            onClick={this.expandOrCollapseLevel}
            href={`/orgchart/icons/blue-${collapsed ? "up" : "down"}-chevron.svg`}
            alt="Level expand/collapse"
          />
        </g>
      </g>
    );
  }
}

export default LevelControl;
